var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_188",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.172,
    y1: 0.5,
    x2: 0.874,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#36953e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ab53f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2200",
    "data-name": "Group 2200",
    transform: "translate(-65 -436)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 65, 436)",
    filter: "url(#Ellipse_188)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_188-2",
    "data-name": "Ellipse 188",
    cx: 26,
    cy: 26,
    r: 26,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1819",
    "data-name": "Group 1819",
    transform: "translate(86.589 450.649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M13.411,28.724c-8.684,0-11.84-.827-11.97-.862L0,27.472l.384-1.441C4.618,10.157,11.974,1.639,12.285,1.284L13.411,0l1.126,1.284c.311.355,7.666,8.872,11.9,24.746l.384,1.441-1.44.39C25.251,27.9,22.095,28.724,13.411,28.724Zm-9.694-3.5a74.314,74.314,0,0,0,9.694.5,74.364,74.364,0,0,0,9.695-.5,66.741,66.741,0,0,0-9.7-20.522,51.711,51.711,0,0,0-2.973,4.584A71.86,71.86,0,0,0,3.716,25.227ZM14.537,3.258Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogo);
export default __webpack_public_path__ + "static/media/icon-logo.d46eaf243d3842a4bd357954c70002f7.svg";
export { ForwardRef as ReactComponent };